export default "__VITE_ASSET__Bpr8tAEV__"